import React from "react";
import imgImageBox from "../assets/images/Hero banner image 1.png";
import imgImage from "../assets/images/hero banner image 2.png";

export default function Hero() {
  return (
    <div className="w-full bg-white relative overflow-hidden flex flex-col gap-8 px-6 pt-28 pb-12 lg:h-[986px] lg:w-[1440px] lg:mx-auto lg:block lg:pt-0 lg:pb-0" data-name="Hero Section">
      {/* Text block */}
      <div className="relative w-full flex flex-col gap-6 lg:absolute lg:left-[150px] lg:top-[264px] lg:w-[601px]" data-name="Title">
        <p className="font-['Inter:Bold',sans-serif] font-bold text-[#0b378d] text-sm lg:text-[16px] tracking-[1.6px] uppercase">
          TRUSTED HOME SERVICES PLATFORM
        </p>
        <div className="flex flex-col gap-[20px] items-start" data-name="Heading">
          <h1 className="font-['Raleway:Bold',sans-serif] font-bold leading-[1.2] text-4xl md:text-5xl lg:text-[64px] text-[#151515] w-full lg:w-[601px]">
            Bringing Trusted Professionals to Your Doorstep!
          </h1>
          <p className="font-['Inter:Medium',sans-serif] font-medium leading-[1.6] text-sm md:text-base lg:text-[18px] text-[#565656]">
            From repairs and maintenance to cleaning and beauty services, book verified professionals in minutes and enjoy reliable, hassle-free service at your doorstep.
          </p>
        </div>
      </div>

      {/* Hero Image Box (Vertical) */}
      <div className="relative w-full max-w-md mx-auto h-[350px] md:h-[450px] rounded-[20px] overflow-hidden lg:absolute lg:left-[801px] lg:top-[264px] lg:w-[510px] lg:h-[695px] lg:mx-0" data-name="Image Box">
        <img alt="Hero banner side" className="absolute inset-0 object-cover size-full pointer-events-none" src={imgImageBox} />
      </div>

      {/* Hero Image bottom (Horizontal) */}
      <div className="relative w-full max-w-md mx-auto h-[180px] md:h-[220px] rounded-[16px] overflow-hidden lg:absolute lg:left-[150px] lg:top-[669px] lg:w-[601px] lg:h-[290px] lg:mx-0" data-name="Image">
        <img alt="Hero banner bottom" className="absolute inset-0 object-cover size-full pointer-events-none" src={imgImage} />
      </div>

      {/* Decorative Ellipse Background blur */}
      <div className="hidden lg:block absolute h-[200px] left-[1207px] top-[122px] w-[190px]">
        <div className="absolute inset-[-200%_-210.53%]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 990 1000">
            <g filter="url(#filter0_f_1_282)" id="Ellipse 34">
              <ellipse cx="495" cy="500" fill="var(--fill-0, #005DE9)" rx="95" ry="100" />
            </g>
            <defs>
              <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="1000" id="filter0_f_1_282" width="990" x="0" y="0">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
                <feGaussianBlur result="effect1_foregroundBlur_1_282" stdDeviation="200" />
              </filter>
            </defs>
          </svg>
        </div>
      </div>
    </div>
  );
}